module.exports = __webpack_public_path__ + "static/img/SmileAnimation_watermelon.a1eb18b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_watermelon.gif
// module id = 3UrJ
// module chunks = 0